import {
  MFA_VERIFY_FACTOR,
  MFA_RESEND_CODE,
  UPDATE_RESEND_CODE_TIMER,
  RESET_SUCCESS_STATE,
  REMEMBER_DEVICE,
  SUCCESS_MESSAGE,
} from "./constants";

export function passcodeSubmit(factorId, rememberDevice, data) {
  return {
    type: MFA_VERIFY_FACTOR,
    data,
    factorId,
    rememberDevice,
  };
}

export function resendCode(factorId, rememberDevice, data) {
  return {
    type: MFA_RESEND_CODE,
    data,
    factorId,
    rememberDevice,
  };
}

export function resetSuccessState() {
  return {
    type: RESET_SUCCESS_STATE,
  };
}

export function updateResendCodeInterval(interval) {
  return {
    type: UPDATE_RESEND_CODE_TIMER,
    data: interval,
  };
}

export function rememberDevice(value = false) {
  return {
    type: REMEMBER_DEVICE,
    data: value,
  };
}

export function mfaSuccessMessage(message) {
  return {
    type: SUCCESS_MESSAGE,
    data: message,
  };
}
